<template>
  <el-row :gutter="15">
    <el-col :span="9">
      <el-card
        header="Key Fields"
        shadow="never"
      >
        <AccountPeekKeyFields :account="event.account" />
      </el-card>
    </el-col>

    <el-col :span="15">
      <el-row class="pb-3">
        <el-col>
          <el-card shadow="never">
            <template #header>
              Events Notes
              <el-button
                type="text"
                @click.native="$refs['eventNotes'].create()"
              >
                New Note
              </el-button>
            </template>
            <Notes
              ref="eventNotes"
              :resource="event"
              truncate
              paginate
              pagination-layout="prev, pager, next"
              :limit="3"
            />
          </el-card>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-card shadow="never">
            <template #header>
              Account Notes
              <el-button
                type="text"
                @click.native="$refs['accountNotes'].create()"
              >
                New Note
              </el-button>
            </template>
            <Notes
              ref="accountNotes"
              :resource="event.account"
              truncate
              paginate
              pagination-layout="prev, pager, next"
              :limit="3"
            />
          </el-card>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import AccountPeekKeyFields from '@/components/Application/CustomerService/Accounts/Account/Peek/KeyFields'
import Notes from '@/components/Notes'
import AccountEvent from '@/plugins/sdk/resources/Account/Event'
import Account from '@/plugins/sdk/resources/Account'

export default {
  components: {
    AccountPeekKeyFields,
    Notes
  },
  props: {
    event: {
      type: Object,
      required: true,
      validator: function (value) {
        return value instanceof AccountEvent &&
          value.account instanceof Account
      }
    }
  }
}
</script>
